import { render, staticRenderFns } from "./createGroup.vue?vue&type=template&id=d8cc13c8&"
import script from "./createGroup.vue?vue&type=script&lang=js&"
export * from "./createGroup.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports